import AnimationClip from '../AnimationClip';
import { Tween, Easing } from '@tweenjs/tween.js';
import GameObject from '../../../GameObject/GameObject';
import ElementComponent from '../../../Component/UI/Element';
import Renderable from '../../../Component/Renderable';

export class PopupTreeShow extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        const element: ElementComponent = gameObject.getComponent(
            ElementComponent
        );
        const renderable: Renderable = gameObject.getComponent<Renderable>(
            Renderable
        );
        renderable.visible = true;
        const targetScale = [1, 1];
        element.layout.scale = [2, 2];

        const tween: Tween = this.getTween(element.layout.scale);

        tween
            .to({ 0: targetScale[0], 1: targetScale[1] }, 400)
            .easing(Easing.Linear.None);

        yield* this.startTween(tween);
    }
}
